<lb-profile-info-box infoBoxIcon="untitled-ui/education/book-open-01" [formGroup]="form()">
	<ng-content right>
		<lb-form-row>
			<lb-form-field>
				<label>Education Level</label>
				<md-drop-down [options]="educationLevelOptions()" placeholder="Make a selection..." formControlName="educationLevel"></md-drop-down>
			</lb-form-field>

			<lb-form-field>
				<label>Graduation Year</label>
				<md-drop-down [options]="graduationYearOptions()" placeholder="Make a selection..." formControlName="graduationYear"></md-drop-down>
			</lb-form-field>
		</lb-form-row>
		<lb-form-row>
			<lb-form-field>
				<label>Current School</label>
				<input type="text" md-form-input formControlName="currentSchool" />
			</lb-form-field>
		</lb-form-row>

		<!-- <lb-form-row>
			<lb-form-field>
				<label>Learning Needs</label>
				<textarea
					md-form-input
					formControlName="learningNeeds"
					rows="3"
					placeholder="Describe any specific learning needs or accommodations..."
				></textarea>
			</lb-form-field>
		</lb-form-row> -->
	</ng-content>
</lb-profile-info-box>
